import React, {Component} from 'react';

export default class PopupBeforeCancel extends Component {

    constructor(props) {
        super(props);

        this.btnCancel = this.btnCancel.bind(this);
        this.hidePopupBeforeCancel = this.hidePopupBeforeCancel.bind(this);
    }

    btnCancel(e) {
        e.preventDefault();
        this.props.handleCancel(this.props.appointment.id);
    }

    hidePopupBeforeCancel() {
        this.props.hidePopupBeforeCancel();
    }

    render() {
        return (
            <div id="popup-hair" className="slickModal isActive">
                <div className="g-popup-overlay slickOverlay closeModal setSlickCookie"></div>
                <div className="g-popup slickWindow animated">
                    <div className="slickCloseBtn close closeModal icon"
                         onClick={this.hidePopupBeforeCancel}
                    ></div>
                    <div className="wrap g-popup-content">
                        <div className="popup-icon"></div>
                        <div className="stylulist">
                            <strong>
                                <p>&nbsp;</p>
                                <p>4+ Hours Notice: No Penalty</p>
                                <p>&nbsp;</p>
                                <p>1- 4 Hours Notice: You will be charged 50 % of the total list price</p>
                                <p>&nbsp;</p>
                                <p>&lt;1 Hour Notice: You will be charged 100% of the total list price</p>
                                <p>&nbsp;</p>
                                <p>Cancellation fees will be charged to Visa</p>
                            </strong>
                        </div>
                    </div>
                    <button
                        className="g-popup-btn button btn-primary buttonEdit"
                        onClick={this.btnCancel}
                    >
                        CANCEL
                    </button>
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/PopupBeforeCancel.js
 **/